import React, { PropTypes } from 'react';
import FanBoxMessageForm from '../FanBoxMessageForm';
import LoadingSpinner from '../../LoadingSpinner';

class FanBoxMessageEdit extends React.Component {
  static propTypes = Object.assign({
    fetch: PropTypes.any,
    loading: PropTypes.bool.isRequired
  });

  componentDidMount() {
    this.props.fetch();
  }

  render() {
    let { loading, rest } = this.props;

    return (
      <LoadingSpinner show={loading}>
        {!loading
          ? (<FanBoxMessageForm label="Create Message" {...rest}/>)
          : null
        }
      </LoadingSpinner>
    );
  }
}

export default FanBoxMessageEdit;




// WEBPACK FOOTER //
// ./src/components/FanBox/FanBoxMessageNew/FanBoxMessageNew.jsx